import React from "react";
import Page from "@atlaskit/page";
import SharedFlowVariablesTable from "./SharedFlowVariablesTable";
import { useSaveShortcut } from "../../../../common/utils/keybindings";
import { useDispatch, useSelector } from "react-redux";
import {
  saveFlow,

} from "../../../../redux/actions/integrationActions";
const SharedFlowVariablesPage = () => {
  const dispatch = useDispatch();
  const saved = useSelector((state) => state.integration.saved);
  const flow = useSelector((state) => state.integration.flow);

  const doSave = () => {
    if (!saved) {
      dispatch(saveFlow(flow));
    }
  };

  useSaveShortcut(doSave);
  return (
    <Page>
      <h4>Flow Variables</h4>
      <h5>Flow Variables available for all actions in this integration flow.</h5>
      <h5>Variables will be put into the scope under <b>_flow</b></h5>
      <SharedFlowVariablesTable />
    </Page>
  );
};

export default SharedFlowVariablesPage;
